import {createContext, useContext} from 'react';
import type {ChecklistStep} from '@chekin/shared/home';
import type {UpsellItem} from './useUpsellItems';

type NavItems = ChecklistStep[];

export interface HomeData {
  bookingRef: string;
  upsellItems: UpsellItem[];
  upsellLoading: boolean;
  navItems: NavItems;
  navLoading: boolean;
  checkInDate?: string;
  checkInTime?: string;
  checkOutDate?: string;
  checkOutTime?: string;
  nights?: number;
  guests?: number;
  propertyName?: string;
}

export const HomeDataContext = createContext<HomeData | null>(null);

export function useHomeData() {
  const ctx = useContext(HomeDataContext);
  if (!ctx) throw new Error('useHomeData must be used within a HomeDataProvider');
  return ctx;
}
